module.exports = __webpack_public_path__ + "static/media/parent_owl.08c17d04.svg";